import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_PLC_SAFETY_DASHBOARD_STATS } from './actionTypes';
import { getPlcSafetyDashboardStatsSuccess, getPlcSafetyDashboardStatsError } from './actions';

// Include call API
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* getPlcSafetyDashboardStats({ payload: { user } }) {
  try {
    const response = yield call(plcSafetyAPI.getDashboardStats, user.token);
    yield put(getPlcSafetyDashboardStatsSuccess(response.stats, response.message));
  } catch (error) {
    yield put(getPlcSafetyDashboardStatsError(error));
  }
}

export function* watchGetPlcSafetyDashboardStats() {
  yield takeEvery(GET_PLC_SAFETY_DASHBOARD_STATS, getPlcSafetyDashboardStats);
}

function* getPlcSafetyDashboardStatsSaga() {
  yield all([fork(watchGetPlcSafetyDashboardStats)]);
}

export default getPlcSafetyDashboardStatsSaga;
